import Dependencies from '../utilities/dependencies';
import InfoBox from '../includes/info-box';
import CmsApi from '../utilities/cms-api';

export default class MosaicHotel {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.mosaic-item-hotel'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.alpine];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	#holderElement;
	/** @type {HTMLElement} */
	#bookingButton;
	/** @type {HTMLElement} */
	#bookingSearchFormElement;
	/** @type {HTMLElement} */
	#closeBtns;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		this.#bookingButton = this.#holderElement.querySelector('.open-booking-search-form-view');
		this.#bookingSearchFormElement = document.querySelector('.booking-search-form-wrapper');
		this.#closeBtns = this.#bookingSearchFormElement.querySelectorAll('.btn-close');
		if (this.#bookingButton) {
			this.#handleBookingBtn();
		}
	}

	#handleBookingBtn() {
		let self = this;
		this.#bookingButton.addEventListener('click', function (){
			if (window.innerWidth <= 992) {
				document.querySelector('header.mobile-view').querySelector('.open-booking-search-form-view').click();
			} else {
				document.querySelector('header.desktop-view').querySelector('.open-booking-search-form-view').click();
			}
		});
	}
}
